import React, { Component } from 'react';
import TextButton from '../components/TextButton';
import { FullscreenImage } from '../components/FullscreenImage';
import NavMenu from '../components/NavMenu';
import options from "../containers/MusicPlayerOptions";

class Home extends Component {
  state = {};
  render() {
    return (
      <FullscreenImage image="/images/HueWeb.BW.Denim.Man.jpg">
        <NavMenu menuList={this.props.menuList} musicParams={options} />
        <div className="ml-8 pt-8 w-1/3 font-sans">
          <h1 className="mb-5 uppercase tracking-wide font-thin md:text-5xl text-4xl text-white">
            Steven Hue
          </h1>
          <p className="tracking-wide font-hairline text-white md:text-2xl text-sm">
            Vocalist | Producer | Multimedia Artist        
          </p>
        </div> 
        <div className="items-stretch md:w-1/4 w-2/3 md:flex fixed md:right-0 bottom-0 m-20 justify-center">
          <TextButton text='Projects' route='/projects'/>
          <TextButton text='Commissions' route='/commissions'/>
        </div>
      </FullscreenImage>
    );
  }
}

export default Home;